var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 30,
    viewBox: "0 0 25 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.171 15.7833C20.1396 12.0492 23.2462 10.1978 23.3717 10.1351C21.6144 7.56199 18.8845 7.21681 17.9431 7.18544C15.6524 6.9344 13.4245 8.56612 12.2635 8.56612C11.0711 8.56612 9.28245 7.21682 7.33695 7.2482C4.858 7.27958 2.50456 8.72301 1.2494 10.9509C-1.38645 15.5009 0.590436 22.216 3.10077 25.9188C4.35593 27.7388 5.83076 29.747 7.77626 29.6843C9.65901 29.6215 10.3807 28.4919 12.64 28.4919C14.8993 28.4919 15.5583 29.6843 17.5352 29.6529C19.5748 29.6215 20.83 27.8329 22.0538 26.0129C23.5286 23.9419 24.0934 21.9023 24.1248 21.8081C24.0934 21.7767 20.2024 20.2705 20.171 15.7833Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.437 4.76963C17.4412 3.48309 18.1629 1.75723 17.9433 0C16.4684 0.0627582 14.6171 1.00414 13.5816 2.2593C12.6402 3.35757 11.7929 5.14618 12.0126 6.84065C13.6757 6.96617 15.3702 6.0248 16.437 4.76963Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleIcon);
export default __webpack_public_path__ + "static/media/apple-icon.1cdbb4e2271de89e4b15e118a359d382.svg";
export { ForwardRef as ReactComponent };